exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb{display:flex;justify-content:center;align-items:center;flex-direction:column;margin-top:8px}.src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb .src-components-product-styles-___image-comingsoon__nonSearchResultImage___3AnYm{width:400px;background-color:transparent}@media only screen and (max-width:768px){.src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb .src-components-product-styles-___image-comingsoon__nonSearchResultImage___3AnYm{width:300px}}.src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb .src-components-product-styles-___image-comingsoon__nonSearchResultMessage___1Q5EU{font-size:20px;text-align:center;color:#fff}", ""]);

// exports
exports.locals = {
	"nonSearchResult": "src-components-product-styles-___image-comingsoon__nonSearchResult___1vTcb",
	"nonSearchResultImage": "src-components-product-styles-___image-comingsoon__nonSearchResultImage___3AnYm",
	"nonSearchResultMessage": "src-components-product-styles-___image-comingsoon__nonSearchResultMessage___1Q5EU"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/product/styles/image-comingsoon.scss
 ** module id = 895
 ** module chunks = 0
 **/